<template lang="pug">
  b-card.w-100(no-body)
    div(slot="header") {{$t('management_page.statistics_history_cycle_settings')}}
    b-list-group
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('statistics_period')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            b-form-radio-group.ml-2.ref(v-model="form.statistics_delete_period" :options="statisticsOption")
      
      //- b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") 녹화 영상 스토리지
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            b-form-input.w-50.d-inline-block(v-model="form.record_upload_path" size="sm" @click="showDialog('settingStorage', false)" readonly)
            b-btn.ml-2(size="sm" variant="primary" @click="showDialog('settingStorage', true)") 검증

    dialog-setting-storage(:show.sync="show.settingStorage" :isCheck="isCheck")
</template>

<script>
import Switches from "vue-switches"

import DialogSettingStorage from "./dialog/dialogSettingStorage.vue"

export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Switches,
    DialogSettingStorage,
  },
  data() {
    return {
      isCheck: false,
      show: {
        settingStorage: false,
      },
      statisticsOption: [
        { value: 0, text: "30" + this.$t("day") },
        { value: 1, text: "60" + this.$t("day") },
        { value: 2, text: "90" + this.$t("day") },
        { value: 3, text: "6" + this.$t("month") },
        { value: 4, text: "1" + this.$t("year") },
        { value: 5, text: "3" + this.$t("year") },
      ],
    }
  },
  methods: {
    showDialog(type, isCheck) {
      this.isCheck = isCheck
      this.show[type] = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
